import { Css } from "@homebound/beam";

const stepperHeaderPlusFooterHeightInPixels = 385;
export const scrollable = Css.h(`calc(100vh - ${stepperHeaderPlusFooterHeightInPixels}px )`).oa.$;
